import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import Header from "../utils/Header";
import Footer from "../utils/Footer";
import ImageWithOverlay from "../utils/ImageWithOverlay";
import AboutUs from "../../public/images/AboutUs.jpg";
import rain from "./rain.jpg";
import temp from "./temp.jpg";
import blue from "./blue.jpg";

export default function CompleteCareer() {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <>
      <Header />
      <ImageWithOverlay
        image={AboutUs}
        height="400px"
        title="Agri Stack"
        titlePartOne="Agri Stack"
        titlePartTwo=""
      />
      <div className="container mt-5">
        <Grid container rowSpacing={3} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
          <Grid item xs={12} md={4}>
            <div
              onClick={() => setSelectedTab(0)}
              style={{ cursor: "pointer", textAlign: "center" }}
            >
              <img src={rain} alt="Rainfall" style={{ maxWidth: "100%" }} />
              <Typography
                variant="body1"
                fontWeight="bold"
                sx={{ marginTop: 1 }}
              >
                Annual Rainfall Over Paksitan (mm/year)
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12} md={4}>
            <div
              onClick={() => setSelectedTab(1)}
              style={{ cursor: "pointer", textAlign: "center" }}
            >
              <img src={temp} alt="MODIS" style={{ width: "100%" }} />
              <Typography
                variant="body1"
                fontWeight="bold"
                sx={{ marginTop: 1 }}
              >
                  Annual Max Temperature Over Paksitan (C)
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12} md={4}>
            <div
              onClick={() => setSelectedTab(2)}
              style={{ cursor: "pointer", textAlign: "center" }}
            >
              <img src={blue} alt="Sentinel 3" style={{ maxWidth: "100%" }} />
              <Typography
                variant="body1"
                fontWeight="bold"
                sx={{ marginTop: 1 }}
              >
                SENTINEL 3 (300m Resolution)
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </>
  );
}
